import styled from 'styled-components'
import { ReactComponent as ArrowCircleLeftIcon } from 'icons/arrow-circle-left-16.svg'

export const StyledBackButtonIcon = styled(ArrowCircleLeftIcon)`
  width: 16px;
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
`
